import React from "react";

import Styled from "./SnackbarStyles";
import { Grid2 as Grid, Slide } from "@mui/material";
import Button from "../Button/Button";
import { Typography, Color, FONT_FAMILY } from "../../ontego-ui";
import { alignItems, justifyContent, maxWidth } from "@mui/system";

export const Snackbar = (props) => {
    const { id, show, onClick, icon, children, showButton = false, textButtonLabel = "Close", animationDuration = 1000, backgroundColor = Color.primary[400], meterColor } = props

    return (
        <Slide direction="up" in={show} mountOnEnter unmountOnExit>
            <Styled.SnackbarWrapper style={{ backgroundColor: backgroundColor }} id={id}>
                <Styled.Meter style={{ animationDuration: `${animationDuration}ms`, WebkitAnimationDuration: `${animationDuration}ms`, background: meterColor }} />
                <Styled.SnackbarContainer>
                    <Grid container style={{ gap: 24, alignItems: 'center', padding: 16, maxWidth: 1200, justifyContent: 'space-between', margin: "auto", height: '100%' }}>
                        <div style={{ display: 'flex', alignItems: 'center', float: "left" }}>
                            <Styled.SnackbarIconContainer>
                                {icon}
                            </Styled.SnackbarIconContainer>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', marginRight: 'auto' }}>
                            <Typography
                                fontFamily={FONT_FAMILY.PLUS_JAKARTA_SANS_REGULAR}
                                size={14}
                                color={Color.neutral[0]}
                            >
                                {children}
                            </Typography>
                        </div>
                        <div style={{ float: "right" }}>
                            {showButton && (
                                <Button
                                    type="primary"
                                    theme="light"
                                    size="small"
                                    onClick={onClick}
                                >
                                    {textButtonLabel}
                                </Button>
                            )}
                        </div>
                    </Grid>
                </Styled.SnackbarContainer>
            </Styled.SnackbarWrapper>
        </Slide>
    )
}

export default React.memo(Snackbar)